import { useEffect, useState } from 'react';
import { DL_QUERY_STRINGS } from '../../../../../../../constants/dealerLocator.constants';
import { windowService } from '../../../../../../../utils/window.utils.js';

const useSelectedPlace = (): [string, (placeId: string) => void] => {
  const getQuery = (key: string) => new URLSearchParams(windowService().location?.search).get(key);
  const query = getQuery(DL_QUERY_STRINGS.PLACE_ID);
  const [selectedPlaceId, setSelectedPlaceId] = useState(query ?? '');
  const [urlQueryText, setUrlQueryText] = useState<string>(selectedPlaceId);

  useEffect(() => {
    if (!query || query === urlQueryText) {
      if (!query) {
        setSelectedPlaceId('');
      }
      return;
    }

    setSelectedPlaceId(query);
  }, [query, urlQueryText]);

  useEffect(() => {
    setUrlQueryText(query ?? '');
  }, [query]);

  return [selectedPlaceId, setSelectedPlaceId];
};

export default useSelectedPlace;
